import { Page } from '../models/Elements';
import { Treatment } from '../models/Entities';
import { CropType } from '../models/Types';
import dateService from '../services/DateService';
import { coreApiAxios } from './CustomAxios';

class TreatmentApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        plotId?: number,
        crop?: CropType,
        searchText?: string
    ): Promise<Page<Treatment>> => {
        const response = await coreApiAxios.get<Page<Treatment>>('/treatments', {
            params: { page, size, sortField, sortOrder, plotId, crop, searchText }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((treatment) => this.loadDates(treatment));

        return response.data;
    };

    get = async (id: number): Promise<Treatment> => {
        const response = await coreApiAxios.get<Treatment>(`/treatments/${id}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (treatment: Treatment): Promise<Treatment> => {
        const response = await coreApiAxios.post<Treatment>(`/treatments`, treatment);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (treatment: Treatment): Promise<Treatment> => {
        const response = await coreApiAxios.put<Treatment>(`/treatments/${treatment.id}`, treatment);
        this.loadDates(response.data);

        return response.data;
    };

    delete = async (id: number): Promise<void> => {
        const response = await coreApiAxios.delete<void>(`/treatments/${id}`);

        return response.data;
    };

    /**
     * Loads the dates of a treatment.
     * @param treatment - the treatment
     */
    private loadDates(treatment: Treatment) {
        treatment.startDate = dateService.transformDate(treatment.startDate)!;
        treatment.endDate = dateService.transformDate(treatment.endDate)!;
        treatment.audit!.created = dateService.transformDate(treatment.audit!.created)!;
        treatment.audit!.updated = dateService.transformDate(treatment.audit!.updated)!;
    }
}

const treatmentApi: TreatmentApi = new TreatmentApi();
export default treatmentApi;
